var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.5 6.00033V13.992C7.5 16.667 9.16667 18.3337 11.8333 18.3337H13.9917C16.6583 18.3337 18.325 16.667 18.325 14.0003V6.00033C18.3333 3.33366 16.6667 1.66699 14 1.66699H11.8333C9.16667 1.66699 7.5 3.33366 7.5 6.00033Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64162 6.7666L1.84995 9.55827C1.60828 9.79994 1.60828 10.1999 1.84995 10.4416L4.64162 13.2333C4.88328 13.4749 5.28328 13.4749 5.52495 13.2333C5.76662 12.9916 5.76662 12.5916 5.52495 12.3499L3.79995 10.6249H12.7083C13.05 10.6249 13.3333 10.3416 13.3333 9.99993C13.3333 9.65827 13.05 9.37493 12.7083 9.37493H3.79995L5.52495 7.64994C5.64995 7.52494 5.70828 7.3666 5.70828 7.20827C5.70828 7.04993 5.64995 6.88327 5.52495 6.7666C5.28328 6.5166 4.89162 6.5166 4.64162 6.7666Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0a1c45211a4a8921ecc81312399c60c6.svg";
export { ForwardRef as ReactComponent };